import { Component, OnInit } from "@angular/core";
import { Router, RouterLink } from "@angular/router";
import { DataTablesModule } from "angular-datatables";

import { CommonModule } from "@angular/common";
import { PaginatorModule } from "primeng/paginator";
import {
  API_URLS,
  DATEFORMATE,
  PAGINATION,
} from "../../../config/app.constants";
import { HttpinterceptorService } from "../../../shared/services/httpinterceptor.service";
@Component({
  selector: "app-saved-bookings",
  templateUrl: "./saved-bookings.component.html",
  styleUrls: ["./saved-bookings.component.scss"],
  standalone: true,
  imports: [RouterLink, DataTablesModule, CommonModule, PaginatorModule],
})
export class SavedBookingsComponent implements OnInit {
  paginate: any = { per_page: 10, current_page: "", total: "", length: 10 };

  perPage = PAGINATION;

  format: string = DATEFORMATE;
  bookings: any = [];
  petNamesList = [];

  constructor(private router: Router, private http: HttpinterceptorService) {}

  ngOnInit() {
    this.getSavedBookings();
  }

  getSavedBookings() {
    const apiSendData = JSON.parse(JSON.stringify(this.paginate));
    this.http
      .post(API_URLS.GET_SAVED_BOOKINGS_LIST, apiSendData, false)
      .subscribe((response) => {
        this.bookings = response.data.data;
        this.paginate.per_page = response.data.per_page;
        this.paginate.current_page = response.data.current_page;
        this.paginate.total = response.data.total;
      });
  }

  redirectToBookingPage(cageData) {
    let petTypeId, cageTypeId, bookingId;

    petTypeId = cageData?.pet_type_slug
      ? cageData?.pet_type_slug
      : cageData?.pet_type_id;

    cageTypeId = cageData?.cage_type_slug
      ? cageData?.cage_type_slug
      : cageData?.cage_type_id;

    bookingId = cageData?.saved_booking_unique_id
      ? cageData?.saved_booking_unique_id
      : cageData?.id;

    this.router.navigate([
      "/saved_cage_booking/",
      petTypeId,
      cageTypeId,
      bookingId,
    ]);
  }
  paginateApply(event) {
    this.paginate.per_page = 10;
    this.paginate.start = event.page * 10;
    this.paginate.length = 10;
    this.paginate.draw = 1;
    this.getSavedBookings();
  }
}
